// src/components/MainLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom'; // ★ 핵심: 자식 페이지들이 들어갈 구멍
import { useAuth } from '../contexts/authContext';
import GlobalGuestTimer from './GlobalGuestTimer';
import { API_URL } from '../lib/config'; // config 경로에 맞게 수정해주세요
import { useSideMenuLogic } from '../hooks/useSideMenuLogic';
import SideMenu from './SideMenu';
import { signOut } from 'firebase/auth'; // [추가] 로그아웃 함수
import { auth } from '../firebase-config'; // [추가] auth 객체
import { useSocket } from '../contexts/socketContext'; // [추가] 소켓 끊기용
import './MainLayout.css';

const MainLayout = () => {
  const { currentUser } = useAuth();
  const socket = useSocket(); // [추가] 소켓 객체 가져오기

  const [expireAt, setExpireAt] = useState(null);
  const [isGuest, setIsGuest] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const menuLogic = useSideMenuLogic();

  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVh(); // 초기 실행
    window.addEventListener('resize', setVh); // 화면 크기 변할 때마다 재계산
    return () => window.removeEventListener('resize', setVh);
  }, []);

  // [추가] 시간이 다 됐을 때 실행될 "저승사자" 함수 💀
  const handleForceLogout = async () => {
    // 1. 사용자에게 마지막 알림
    alert("⏳ 체험 시간이 모두 종료되었습니다.\n데이터가 초기화되며 메인 화면으로 이동합니다.");

    try {
      // 2. 소켓 연결 강제 종료 (채팅 차단)
      if (socket) {
        socket.disconnect(); 
      }

      // 3. Firebase 로그아웃
      await signOut(auth);

      // 4. 페이지 강제 새로고침 & 메인 이동
      // (navigate 대신 location.href를 써야 메모리에 남은 상태까지 깔끔하게 날아갑니다)
      window.location.href = '/'; 
      
    } catch (error) {
      console.error("강제 퇴장 처리 중 오류:", error);
      window.location.href = '/'; // 에러 나도 무조건 쫓아냄
    }
  };

  useEffect(() => {
    const fetchUserStatus = async () => {
      // 1. 로그인이 안 되어 있으면 초기화
      if (!currentUser) {
        setIsGuest(false);
        setExpireAt(null);
        setIsReady(false);
        return;
      }

      try {
        // 2. 서버에 내 정보 요청 (/me API 재활용)
        const idToken = await currentUser.getIdToken();
        const response = await fetch(`${API_URL}/api/login/me`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${idToken}` }
        });

        if (response.ok) {
          const data = await response.json();
          
          if (data.user) {
             // 1. 게스트 여부 체크 및 시간 설정
             if (data.user.isGuest) {
               setIsGuest(true);
               setExpireAt(data.user.expireAt);
             } else {
               setIsGuest(false);
               setExpireAt(null);
             }

             // 2. ★★★ [핵심] 게스트든 정회원이든 정보 로드 성공했으니 Ready! ★★★
             setIsReady(true); 
          }
        }
      } catch (error) {
        console.error("게스트 정보 조회 실패:", error);
      }
    };

    fetchUserStatus();
  }, [currentUser]);

//   return (
//     // 게스트일 때만 상단 여백 클래스 추가 (타이머에 가려지지 않게)
//     <div className={isGuest ? "has-guest-timer" : ""}>
      
//       {/* 1. 조건이 맞으면 전역 타이머 노출 */}
//       {isGuest && expireAt && (
//         <GlobalGuestTimer expireAt={expireAt} />
//       )}

//       {/* 2. 실제 페이지 내용은 여기(Outlet)에 렌더링됨 */}
//       <Outlet />
      
//     </div>
//   );
  return (
    // <div className={`main-layout ${isGuest ? "has-guest-timer" : ""}`}>
    <div className="main-layout">
      
      {/* 3. 전역 타이머 */}
      {isGuest && expireAt && (
        <GlobalGuestTimer
            expireAt={expireAt}
            onExpired={handleForceLogout}
        />
        )}

      {/* 4. 사이드 메뉴 (여기에 한 번만 배치!) */}
      <SideMenu
        isOpen={menuLogic.isMenuOpen}
        onClose={menuLogic.toggleMenu}
        isAuthenticated={!!currentUser}
        isReady={isReady}
        onLoginClick={menuLogic.togglePopup}
        onProfileClick={menuLogic.handleProfileClick}
        onInboxClick={menuLogic.handleInboxClick}
        onRealtimeChatClick={menuLogic.handleRealtimeChatClick}
        onHomeClick={menuLogic.handleHomeClick}
        onNoticeClick={menuLogic.handleNoticeClick}
        onSettingsClick={menuLogic.handleSettingsClick}
        onFriendListClick={menuLogic.handleFriendListClick}
      />

      {/* 5. 로그인 팝업 (여기에 한 번만 배치!) */}
      {menuLogic.isPopupOpen && (
        <div className="popup-overlay" onClick={menuLogic.togglePopup}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <button className="oauth-button google" onClick={menuLogic.handleGoogleLogin}>
              Google로 계속하기
            </button>
            {/* ▼▼▼ [신규 추가] 애플 로그인 버튼 ▼▼▼ */}
            <button className="oauth-button apple" onClick={menuLogic.handleAppleLogin}>
              Apple로 계속하기
            </button>
          </div>
        </div>
      )}

      {/* 6. 자식 페이지 렌더링 (리모컨 전달) */}
      {/* context로 toggleMenu 함수를 내려보냅니다. */}
      <div className="layout-wrapper">
        <Outlet context={{ toggleMenu: menuLogic.toggleMenu, togglePopup: menuLogic.togglePopup }} />
      </div>
      {/* <Outlet context={{ toggleMenu: menuLogic.toggleMenu, togglePopup: menuLogic.togglePopup }} /> */}
      
    </div>
  );
};

export default MainLayout;